import * as LabelPrimitive from '@radix-ui/react-label';
import type * as React from 'react';
import { cn } from '../lib/cn.js';

const labelClassName =
  'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70';

export function Label({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return <LabelPrimitive.Root className={cn(labelClassName, className)} {...props} />;
}
